import React from "react";
import { useLocation } from "react-router-dom";

function Footer() {
  const location = useLocation();
  const isTandCPage = location.pathname === "/TermsConditions";
  const isPandPPage = location.pathname === "/privacy";

  return (
    <div>
      <footer className="site-footer">
        <div>
          {/* First Row: FoneApp Logo */}
          <div className="sec1row">
            <div className="col-12 mb-4">
              <img
                src="images/icons/Foneapp Logo-03.png"
                alt="FoneApp Logo"
                className="foneapp-logo"
              />
            </div>
          </div>

          <div>
            <header className="site-header2"></header>
          </div>

          {/* Second Row: About Us, Privacy Policy, Join FoneApp */}
          <div className="row sec2row">
            <div className="col-lg-4 col-md-4 col-12">
              <ul className="footer-menu">
                <li className="footer-menu-item">
                  <a
                    href={
                      isTandCPage || isPandPPage
                        ? "/#AboutUs"
                        : "#AboutUs"
                    }
                    className="footer-menu-link"
                  >
                    About Us
                  </a>
                </li>
                <li className="footer-menu-item">
                  <a
                    href={
                      isTandCPage || isPandPPage
                        ? "/#section_M20"
                        : "#section_M20"
                    }
                    className="footer-menu-link"
                  >
                    M2O Loyalty Program
                  </a>
                </li>
                <li className="footer-menu-item">
                  <a
                    href={
                      isTandCPage || isPandPPage
                        ? "/#section_Partner"
                        : "#section_Partner"
                    }
                    className="footer-menu-link"
                  >
                    Be Our Partner
                  </a>
                </li>
                <li className="footer-menu-item">
                  <a
                    href={
                      isTandCPage || isPandPPage
                        ? "/#section_FonePlus"
                        : "#section_FonePlus"
                    }
                    className="footer-menu-link"
                  >
                    FonePlus
                  </a>
                </li>
                <li className="footer-menu-item">
                  <a
                    href={
                      isTandCPage || isPandPPage
                        ? "/#section_Team"
                        : "#section_Team"
                    }
                    className="footer-menu-link"
                  >
                    Our Team
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-4 col-12">
              <ul className="footer-menu">
                <li className="footer-menu-item">
                  <a href="privacy" className="footer-menu-link">
                    Privacy Policy
                  </a>
                </li>
                <li className="footer-menu-item">
                  <a href="TermsConditions" className="footer-menu-link">
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-4 col-12">
              <h5 className="site-footer-title">Join FoneApp</h5>
              <a href="#cluth" className="footer-menu-link">
                Get exclusive deals by signing up to our FoneApp.
              </a>
            </div>
          </div>

          {/* Third Row: Copyright and Download Links */}
          <div className="row site-footer-bottom align-items-center sec3row">
            <div className="col-lg-6 col-md-6 col-12">
              <p className="copyright-text">
                2024 © FoneApp, All rights Reserved. Powered by MV Asia Sdn Bhd.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-12 alignrow">
              <h5 className="site-footer-title1">Download here</h5>
              <ul className="download-links">
                <li>
                  <a href="https://play.google.com/store/apps/details?id=io.mxapps.forestone&pli=1">
                    <img src="images/icons/Google Play.png" alt="Google Play" />
                  </a>
                </li>
                <li>
                  <a href="https://apps.apple.com/my/app/foneapp-forestone/id1513862024">
                    <img src="images/icons/Apple store.png" alt="App Store" />
                  </a>
                </li>
                <li>
                  <a href="https://appgallery.huawei.com/app/C102355583">
                    <img
                      src="images/icons/Huawei App Gallery 2.png"
                      alt="App Gallery"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div>
        <header className="site-header3"></header>
      </div>
    </div>
  );
}

export default Footer;
